import { FilterList } from '@mui/icons-material'
import {
  Grid,
  Toolbar,
  Button,
  useMediaQuery,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Typography,
} from '@mui/material'
import { Theme } from '@mui/material/styles'
import I18n from 'i18n-js'
import { ReactElement, isValidElement, useState } from 'react'

import SearchableFilter, {
  SearchableFilterProps,
} from '@src/components/shared/Filter/SearchableFilter'
type FilterItem = ReactElement | SearchableFilterProps
const ContentFilters: React.FC<
  React.PropsWithChildren<{
    filterItems: FilterItem[]
    onClear?: () => void
  }>
> = ({ filterItems, onClear }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  return (
    <Toolbar disableGutters>
      <Accordion
        expanded={!isMobile ? true : isMobileOpen}
        square
        disableGutters
        sx={{
          'width': '100%',
          'border': 'none',
          'boxShadow': 'none',
          'background': 'none',
          '& .MuiAccordionSummary-content': {
            justifyContent: 'center',
          },
          '& .MuiAccordionDetails-root': {
            padding: 0,
          },
        }}
      >
        <AccordionSummary
          sx={{
            display: { xs: 'block', sm: 'none' },
          }}
        >
          <Button
            variant="text"
            sx={{ color: 'text.primary' }}
            startIcon={<FilterList fontSize="medium" />}
            onClick={() => setIsMobileOpen(!isMobileOpen)}
          >
            {isMobileOpen
              ? I18n.t('filters.hideFilters')
              : I18n.t('filters.showFilters')}
          </Button>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={3} alignItems="center">
            {filterItems.map((filter: FilterItem, i: number) => (
              <Grid
                key={filter?.key || `filter-item-key-${i}`}
                item
                sm={3}
                xs={12}
              >
                {isValidElement(filter) ? (
                  filter
                ) : (
                  <SearchableFilter {...(filter as SearchableFilterProps)} />
                )}
              </Grid>
            ))}
            {onClear && (
              <Grid
                item
                // clear has a minimum of 2 columns but should fill the rest of the space
                sm={Math.max(2, 12 - filterItems.length * 3)}
                xs={12}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: isMobile ? 'flex-start' : 'flex-end',
                }}
              >
                <div>
                  <Button variant="text" onClick={() => onClear()}>
                    <Typography>{I18n.t('filters.clear')}</Typography>
                  </Button>
                </div>
              </Grid>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Toolbar>
  )
}

export default ContentFilters
